import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import {Link } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
import { currentTenant, financialyearend, thousandsdisplay, transactionFrom } from '../../Common/Credentials';
import { Spinner, ThemeProvider } from 'react-bootstrap';
import Header from '../../Component/Header';
import Menu from '../../Component/Menu';
import { spin } from '../../Common/NewLoader';
import Footer from '../../Component/Footer';
import MUIDataTable from "mui-datatables";
import { createTheme,FormControlLabel,TextField } from "@mui/material";
import NewLedgerService from "../Ledgers/NewLedgerService";
import { Autocomplete,Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import moment from "moment";
import { id } from "date-fns/locale";
import IOSSwitch from "../../CommonComponents/IOSSwitch.js";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import NewJournalService from "../NewJournalService";



export default function LedgersRealAL(props){
  const history = useLocation();
  const [loader] = useState(false);
  const [ledger, setLedgers] = useState([]);
  const [selectedLed, setselectedLed] = useState([]);
  const [fsd, setFsd] = useState(null);
  const [fed, setFed] = useState(null);
  const [selid, setSelid] = useState(null);
  const [SDdate, setSDdate] = useState([false]);
  const [selectedledger, setSelectedledger] = useState('');

  
  const theme = createTheme({
    overrides: {
      MuiTableCell: {
        head: {
          backgroundColor: "#e9ecef !important",
          border: [[1, "solid", "#ece6e6"]],
        },
        body: {
          border: [[1, "solid", "#ece6e6"]],
        },
      },
    },
  });


useEffect(() => {
  NewJournalService.getrllov(currentTenant).then((response) =>{
    setLedgers(response.data);
  });
  },[]);

  const submitRecord=(value)=>{
    let directaddedstock
    if(value!==undefined){
  //  directaddedstock=dirstock.filter(e=>e.id===value.rowData[0])
    } 
    history.push(`/dirstockentry`, {directaddedstock});
   }

    function handleSDDate() {
    setSDdate(SDdate===true?false:true)
    if(SDdate===false){
      setFed(null)
      setFsd(null)
    }
  }

   function getData() {
         setselectedLed([]);
        let data={
        tenantId:currentTenant,
        fromDate:fsd,
        toDate:fed,
        ledid:selid
      }
     // console.log(data)
      NewLedgerService.getRealLedgersView(data).then((response) =>{
        setselectedLed(response.data);
      });
    }
  
     function  handleFsdDateChange(date) {
        if(date!==null){
        //setFsd(date)
        setFsd(`${moment(date.$d).format("yyyy-MM-DD")} 00:00:01.000`)
          // moment(date.$d).format("yyyy-MM-DD") 00:00:01.000`) //format("yyyy-MM-DD HH:mm:ss"))
      }else{
        setFsd(null)
        setSDdate(false)
      }
      };
  
      function  handleFsdDateChange1(date) {
          if(date!==null){
         // setFsd(date)
          setFed(`${moment(date.$d).format("yyyy-MM-DD")} 23:59:59.999`)
//moment(date.$d).format("yyyy-MM-DD HH:mm:ss")
        }else{
          setFed(null)
          setSDdate(false)
        }
        };


  const Ledgercolumns = [
    {
      name: "behav",
      label: "EntryType",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "createdAt",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        sortOrder: 'asc',
        customBodyRender: (tableMeta) => {
          return moment(tableMeta).format("DD-MM-YYYY hh:mm");
        },
      },
    },    
    {name: "orderid",label: "Type",options: {filter: false,sort: true,}},
    {name:"debitname",label:"Dr Ledger",options: {filter: true,sort: true,
    //  customBodyRender: (tableMeta, values) => {
    //    // console.log(values.rowData.find((e) => e))
    //     return values.rowData.find((e) => e) !== 1?tableMeta:"-NA-"

    //      }
      }},
      {name:"creditname",label:"Cr Ledger",options: {filter: true,sort: true,
        // customBodyRender: (tableMeta, values) => {
        //   // console.log(values.rowData.find((e) => e))
        //    return values.rowData.find((e) => e) === 1?tableMeta:"-NA-"
   
        //     }
         }},

    {
      name: "currentamt",
      label: "Previous/Opening Balance",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (tableMeta) => {
          return (
            <NumericFormat
              className="pr-3"
              displayType={"text"}
              value={tableMeta}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            ></NumericFormat>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "jvamount",
      label: "Debit",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (tableMeta, values) => {
          //  console.log(values.rowData[10])
          return (
            <>
             {values.rowData[10] ==="DEBIT" ?//("+"):("-")}
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> :0}
            </>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "jvamount",
      label: "Credit",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (tableMeta, values) => {
          return (
            <>
              {values.rowData[10]=== "CREDIT"  ?
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={tableMeta}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat> : 0}
            </>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
      },
    },

    {
      name: "amount",
      label: "Current/Closing Balance",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (tableMeta) => {
          return (
            <NumericFormat
              className="pr-3"
              displayType={"text"}
              value={tableMeta}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            ></NumericFormat>
          );
        },
        setCellProps: (value) => ({ style: { textAlign: "right" } }),
        //   customHeadRender: (columnMeta,) => (
        //     <div style={{style: { textAlign:'right'}}}>
        //         {columnMeta.name}
        //     </div>
        // )
      },
    },

    {
      name: "id",
      label: "Transaction",
      options: {
        filter: true,
        sort: true,

        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            // <>
            //   {value !== null ? (
                <Link
                  as="button"
                  data-tip
                  data-for="view"
                  to={{ pathname: "/jvdetails"}} state= {{ id: value}}
                >
                  {value.id}
                </Link>
            //   ) : tableMeta.rowData[7] !== null ? (
            //     <Link
            //       as="button"
            //       data-tip
            //       data-for="view"
            //       to={{
            //         pathname: "/jvdetails"}}
            //         state={{ id: tableMeta.rowData[7]}}
            //     >
            //       {tableMeta.rowData[7].id}
            //     </Link>
            //   ) : (
            //     "Opening"
            //   )}
            // </>
          );
        },
      },
      setCellProps: (value) => ({ style: { textAlign: "center" } }),
    },
    {
      name: "entryType",
      label: "EntryType",
      options: {
        filter: false,
        sort: false,
         display: false,
        viewColumns: false,
      },
    },


    //{name: "warehouse",label:"Branch/Warehouse",options: {filter: false,sort: true,}},
   // {name: "price",label: "Unit Price",options: {filter: false,sort: true,sortOrder: 'asc',
    //   customBodyRender:(tableMeta)=>{
    //     return(<NumericFormat className="pr-3" displayType={'text'} value={tableMeta} decimalScale={2} fixedDecimalScale={true} disabled ={true} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat>)
    //   },
    //   setCellProps: value => ({ style: { textAlign:'right'}}),
    // }},
    // {name: "amount",label: "Total Amount",options: {filter: false,sort: true,sortOrder: 'asc',
    //   customBodyRender:(tableMeta)=>{
    //     return(<NumericFormat className="pr-3" displayType={'text'} value={tableMeta} decimalScale={2} fixedDecimalScale={true} disabled ={true} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat>)
    //   },
    //   setCellProps: value => ({ style: { textAlign:'right'}}),
    // }},
    // {name: "id",label:<span className="text-bold">Action</span>,options: {filter: false,sort: false,display:true,viewColumns:false,    
    //   customBodyRender:(value,tableMeta)=>{
    //     return (
    //       value.length!==0 ?<button className="hovbuttonColour btn btn-sm"
    //       onClick={() => submitRecord(tableMeta)}>  {loader===true? <><Spinner animation="border" size="sm" />&nbsp;{"Submitting"}</>:"Pass Entry"}
    //       </button>:<span className="text-red text-bold">No Values</span>
    //     );      
    //   },
    //   setCellProps: value => ({ style: { outerHeight:100}}),
    // }},
   ];


   const Ledgeroptions = {
    filterType: 'checkbox',
    selectableRows: "none",
    resizableColumns: true,

  }

   const onLedgerSelect=(value, values)=>{
    if (!value || value==null ||value=='' || value=="" || value == undefined) {
            setSelid(null)

      // let val1 = val.filter(e=>e.jvid !== null?e.jvid:e.cjvid)
      //console.log(val)
      // this.setState({ selectedLed: val, selectedledger: value });
    }else{
      let val = ledger.filter((e) => e.name === value);//.sort((a,b)=> a.createdAt<b.createdAt ? 1:-1);
      //setselectedLed(val)
      setSelectedledger(value)
      let a
      val.map((e)=>{return a=e.id})
      setSelid(a)
    }
  }

  const val=<span className="textColor">Default last 90 days data is fetched</span> 
  const ledgers = [
    ...new Set(
      ledger.map((e) => {
       // return e.ledgercode!==null?e.ledgername.concat(" [" + e.ledgercode + "]"):e.ledgername;
        return e.name;
      })
    ),
  ];

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item text-secondary">
              <Link to="/accounts">Home</Link>
            </li>
            <li className="breadcrumb-item active">Ledgers</li>
          </ol>
          <div className="form-row">
            <div className="card-body">
              <div>
                {ledger === null ? (
                  <div className="text-center">{spin}</div>
                ) : (
                  <>
                  <div className="mb-5">
                  <Formik
                  initialValues={{ ledgersel: "", ledgers }}
                  enableReinitialize={true}
                >
                  {({ values, setFieldValue }) => (
                    <Form autoComplete="off">
                      {/* <span className="text-red"> This is under development. Will be available ASAP</span> */}
                  <div className="form-row col-md-12 mt-0 mb-0">
                  <fieldset className="form-group col-md-6 mt-0 mb-3">
                          <Autocomplete
                            id="aledgers"
                            className="grn-select "
                            name="aledersel"
                            options={ledgers}
                            getOptionLabel={(option) => option}
                            value={values.ledgersel ? undefined : undefined}
                            onChange={(e, value) => {
                              setFieldValue("ledgersel", value);
                            }}
                            renderInput={(params) => (
                              <FormikTextField
                                {...params}
                                className="form-control mb-3"
                                type="text"
                                name="ledgersel"
                                label={selid===null?<span className="text-red">Select A/L Ledger</span>:<span className="black">Select A/L Ledger</span>}
                                onBlur={(e) => {
                                  onLedgerSelect(e.target.value, values);
                                }}
                                variant="standard"
                                fullWidth
                              />
                            )}
                          />
                        </fieldset>
                        <fieldset className="form-group col-md-6 mt-0 mb-3 text-right">

                 <Link className="btn fas buttonColour text-yellow fa-money-bill-alt"
                  to={{ pathname: "/ledgertax" }}
                    state={{ message: "" }}
                      >
                    &nbsp;&nbsp;&nbsp;Tax Ledgers</Link>

                          </fieldset></div>

{/* <div>{SDdate===false?val:null}</div> */}
                  <span className="text-red"> </span>         
   <div className="form-row col-md-12 text-left mt-3">
    
    {/* <div className="form-row col-md-12 text-left">
  <FormControlLabel
   control={<IOSSwitch className="sm" onChange={handleSDDate} name="checkedB" />}/> 
     <span className="text-left textColour">{SDdate===false?" Default Values":" Custom Dates"}</span>
       </div> */}
    {/* {SDdate===true?<> */}

     <div className="form-group col-md-1 text-left">
    <label>{fsd!==null?<span>From Date</span>:<span className="text-red">From Date</span>}</label></div>
    <div className="form-group col-md-4 text-left">
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Grid  justifyContent="space-around">
    <DatePicker disableFuture showTodayButton showCancelButton variant="standard" 
    id="date-picker-dialog" inputVariant="standard"
    //minDate={new Date(moment(this.state.crdate).format("yyyy-MM-DD"))}
    minDate={new Date(moment(transactionFrom).format("yyyy-MM-DD"))}
    format="dd/MM/yyyy HH:mm" value={fsd}
    // label="Custom Date" 
    //crdate financialyearstart
    InputAdornmentProps={{position: "start"}} onChange={handleFsdDateChange}
    renderInput={(params) => <TextField {...params} variant="standard"/>} autoOk={true}/>
    </Grid></LocalizationProvider>
    </div>
<div className="form-group col-md-1 text-left">
<label>{fed!==null?<span>To Date</span>:<span className="text-red">To Date</span>}</label></div>
<div className="form-group col-md-4 text-left">
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid  justifyContent="space-around">
<DatePicker disableFuture showTodayButton showCancelButton variant="standard" 
id="date-picker-dialog" inputVariant="standard"
//minDate={new Date(moment(this.state.crdate).format("yyyy-MM-DD"))}
maxDate={new Date(moment(financialyearend).format("yyyy-MM-DD"))}
format="dd/MM/yyyy HH:mm" value={fed}
// label="Custom Date" 
//crdate financialyearstart
InputAdornmentProps={{position: "start"}} onChange={handleFsdDateChange1}
renderInput={(params) => <TextField {...params} variant="standard"/>} autoOk={true}/>
</Grid></LocalizationProvider></div>
 
{/* </>
     :null
} */}
</div>
{fsd!==null && fed!==null && selid!==null?
<div className="form-group col-md-1 text-left">
      <button
                      type="button"
                      value="Add"
                      onClick={getData}
                      className=" btn btn-sm hovbuttonColour mr-2">
                      Get
                    </button>
                    </div>:<div></div>}

                    <ThemeProvider theme={theme}>
                      <MUIDataTable
                        className="table-sm px-3 text-sm"
                        title={"Ledgers"}
                        id="dirstock"
                        data={selectedLed.map(oth=>{
                          return[oth.behav,oth.createdAt,
                            // oth.orderid!==null && oth.orderid.charAt(0)==='S'?oth.custominvid:oth.orderid!==null && oth.orderid.charAt(0)==='P'?oth.custompoid:oth.genadvanceadded!=null?"Advance":oth.orderid,
                            // oth.jvid!==null?oth.jvid.debitname:oth.cjvid!==null?oth.cjvid.name:"Opening",
                            // oth.jvid!==null?oth.jvid.creditname:oth.cjvid!==null && oth.cjvid.name==="Salaries"?oth.cjvid.cidthname:oth.cjvid!==null?oth.cjvid.cname:"Opening",
                            // oth.jvid!==null?oth.currentamt:oth.cjvid!==null?oth.genadvanceadded!=null?oth.jvamount:oth.currentamt:oth.jvamount,
                            // oth.jvid!==null ?oth.jvamount:oth.cjvid!==null ?oth.jvamount:"Opening", 
                            // oth.jvid!==null ?oth.jvamount:oth.cjvid!==null ?oth.jvamount:null,
                            // oth.genadvanceadded!=null?oth.genadvancecurrent:oth.amount,
                            // oth.jvid!==null?oth.jvid:oth.cjvid!==null?oth.cjvid:"Opening",
                            // oth.entryType!==null?oth.entryType:0
                            oth.ledgername,
                            // oth.jvid!==null?oth.thid==="TH3"?oth.jvid.debitname:oth.jvid.creditname:oth.cjvid!==null?oth.thid==="TH3"?oth.cjvid.name:oth.cjvid.cname:"Opening",
                            // oth.jvid!==null?oth.thid==="TH3"?oth.jvid.creditname:oth.jvid.debitname:oth.cjvid!==null?oth.thid==="TH3"?oth.cjvid.cname:oth.cjvid.name:"Opening",
                            oth.jvid!==null?oth.jvid.debitname:oth.cjvid!==null?oth.cjvid.name:"Opening",
                            oth.jvid!==null?oth.jvid.creditname:oth.cjvid!==null && oth.cjvid.jvinsertiontype==="SALARIES"?oth.ledgername:oth.cjvid!==null?oth.cjvid.cname:"Opening",
                            oth.jvid!==null?oth.currentamt:oth.cjvid!==null?oth.currentamt:oth.jvamount,
                            oth.jvid!==null?oth.jvamount:oth.cjvid!==null?oth.jvamount:"Opening", 
                            oth.jvid!==null?oth.jvamount:oth.cjvid!==null?oth.jvamount:null,
                            oth.amount,
                            oth.jvid!==null?oth.jvid:oth.cjvid!==null?oth.cjvid:"Opening",
                            oth.entryType

                            // oth.jvid!==null?oth.jvid.creditname:"Opening",
                            // oth.jvid!==null?oth.jvid.debitname:"Opening",
                            // oth.jvid!==null?oth.currentamt:oth.jvamount,
                            // oth.jvid!==null?oth.jvamount:"Opening", oth.jvid!==null?oth.jvamount:null,oth.amount,oth.jvid!==null?oth.jvid:"Opening"
                          ]
                        })}
                        columns={Ledgercolumns}
                        options={Ledgeroptions}
                      />
                    </ThemeProvider>
                    </Form>
                  )}
                </Formik>
                    </div>

                  </>
                )} 
              </div>

            </div>
            
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );


}         



 
